import { STRINGS, TUNABLE, noteName, pitchClass, midiToFreq, freqToMidiFloat } from '@/lib/pitch';
import { useReferenceTone } from '@/hooks/useReferenceTone';
import { useTunings } from '@/hooks/useTunings';
import { TuningPicker } from '@/components/tuner/TuningPicker';
import { PercussionPanel } from '@/components/tuner/PercussionPanel';
import { NoteButton, Panel, nearestIndex } from '@/components/tuner/NoteButton';

const WRITTEN_OCTAVE_BASE = 60; // C4 written

const StringsPanel = ({ strings, flats, header, detected, tone, a4 }) => {
  const target = nearestIndex(strings, detected);
  return (
    <Panel title="Corde · tocca per ascoltare" testId="tuner-strings-panel" cols={strings.length} header={header}>
      {strings.map((m, i) => (
        <NoteButton
          key={i}
          testId={`tuner-string-${i}`}
          label={noteName(m, flats).replace(/-?\d+$/, '')}
          sub={noteName(m, flats)}
          corner={strings.length - i}
          compact={strings.length > 6}
          active={tone.playing === `s${i}`}
          target={target === i}
          onClick={() => tone.toggle(`s${i}`, midiToFreq(m, a4))}
        />
      ))}
    </Panel>
  );
};

const TunableStrings = ({ instrumentId, ...rest }) => {
  const tunings = useTunings(instrumentId);
  const { tuning } = tunings;
  return <StringsPanel strings={tuning.notes} flats={!!tuning.flats} header={<TuningPicker tunings={tunings} />} {...rest} />;
};

const NotesPanel = ({ instrument, tone, a4 }) => (
  <Panel title="Nota di riferimento · tocca per ascoltare" testId="tuner-notes-panel" cols={6}>
    {Array.from({ length: 12 }, (_, pc) => {
      const concert = WRITTEN_OCTAVE_BASE + pc - instrument.semitones;
      return (
        <NoteButton
          key={pc}
          testId={`tuner-ref-note-${pc}`}
          label={pitchClass(pc, instrument.group.flats)}
          active={tone.playing === concert}
          onClick={() => tone.toggle(concert, midiToFreq(concert, a4))}
        />
      );
    })}
  </Panel>
);

export const ReferencePanel = ({ instrument, a4, freq, tuningsVersion }) => {
  const tone = useReferenceTone();
  const detected = freq ? freqToMidiFloat(freq, a4) : null;
  const common = { tone, a4, detected };

  if (TUNABLE[instrument.id]) return <TunableStrings key={`${instrument.id}-${tuningsVersion}`} instrumentId={instrument.id} {...common} />;
  if (STRINGS[instrument.id]) return <StringsPanel strings={STRINGS[instrument.id]} flats={false} {...common} />;
  if (instrument.group.perc) return <PercussionPanel key={`${instrument.id}-${tuningsVersion}`} instrumentId={instrument.id} {...common} />;
  return <NotesPanel instrument={instrument} {...common} />;
};
